import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { IFaqs } from '../model/http/faqs.model';
import { IFooter, IDisclaimersFooter } from '../model/http/footer.model';
import { IHomePage } from '../model/http/homepage.model';
import { ILandingPage } from '../model/http/landing.model';
import { ILandingPlanes } from '../model/http/planes.model';
import { IImagesGeneral, IImagesSearcher } from '../model/http/images.model'
import { ConsumeService } from './consume.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StrappiService {
  private readonly dataHomepage = new Subject<any>();

  constructor(
    private readonly consume: ConsumeService,
    private readonly http: HttpClient
  ) { }

  getHome(templateSuffix: string): Observable<IHomePage> {
    const endpoint = templateSuffix === '' ? Endpoints.strappi.homepage : Endpoints.strappi.homepageB;
    return this.consume.httpGet(endpoint);
  }

  setDataHomepage(data: any): void {
    this.dataHomepage.next(data);
  }

  getDataHomepage(): Observable<any> {
    return this.dataHomepage.asObservable();
  }

  getFaqs(): Observable<IFaqs> {
    return this.consume.httpGet(`${Endpoints.strappi.faqs}`)
  }

  getFooter(): Observable<IFooter> {
    return this.consume.httpGet(`${Endpoints.strappi.footerB}`)
  }

  getLandingPage(): Observable<ILandingPage[]> {
    return this.consume.httpGet(`${Endpoints.strappi.staticPage}`)
  }

  getBoletin(): Observable<ILandingPage[]> {
    return this.consume.httpGet(`${Endpoints.strappi.boletin}`)
  }

  getPlanPage(): Observable<ILandingPlanes> {
    return this.consume.httpGet(`${Endpoints.strappi.planPage}`)
  }

  getImagesSearcher(): Observable<IImagesSearcher> {
    return this.consume.httpGet(`${Endpoints.strappi.imagesSearcher}`)
  }

  getImagesGeneral() {
    return this.http.get<IImagesGeneral>(`${Endpoints.strappi.imagesGeneral}`)
  }

  getDisclaimers(): Observable<IDisclaimersFooter> {
    return this.consume.httpGet(`${Endpoints.strappi.disclaimers}`)
  }
  
  getLandingBanners(): Observable<any> {
    return this.consume.httpGet(`${Endpoints.strappi.landings}`)
  }
}
